import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import { PublishProgressIcon } from '~/ui/core/stats/icons/PublishProgressIcon';

import { StatusIndicator } from './StatusIndicator';

export const PublishedBadge: FunctionComponent<{ readonly size?: 'sm' | 'md' }> = ({ size = 'sm' }) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <StatusIndicator
            className="text-status-published"
            data-testid="review-state-published"
            icon={<PublishProgressIcon colorBase="currentColor" colorFill="currentColor" progress={1} />}
            size={size}
        >
            {translate('pages.job-architecture-v2.review-state.published')}
        </StatusIndicator>
    );
};
